import React from 'react';
import  { PickupPointBasicInfoComponent } from './pickup-point-basic-info.component';
import PickupAddressComponent from './pickup-point-address.component';
import TabContainer from '../../../../../../../common/components/tab/containers/tab.containers';

function PickupPointComponent ({ stores, handleInnerbasicFormChange, back, onInnerFormChange, handleFormSubmit, selectedAddress, selectedPickupPoint }: any) {
    const tabItems=[
        {
            id:1,
            title:'Basic Information',
            component:  <PickupPointBasicInfoComponent
            onInnerFormChange={onInnerFormChange}
            selectedPickupPoint={selectedPickupPoint}
            stores={stores}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'Address',
            component: <PickupAddressComponent
            handleInnerbasicFormChange={handleInnerbasicFormChange}
            selectedAddress={selectedAddress}
            onInnerFormChange={onInnerFormChange} 
            selectedPickupPoint={selectedPickupPoint}
           />,
            isVisible:true,
        }
     
      
      ]

  return (<>
  <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
       <TabContainer tabItems={tabItems} />
    
       <div className='flex w-full justify-end items-end'>
         <button
               onClick={back}
               type='button'
               className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              >
               Back
              </button>
              <button
             className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
               onClick={handleFormSubmit}
             
               type="submit"
           >
             Save
           </button>
         </div>
        </div>

     </> 
  );
}
export default PickupPointComponent;
